// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { postLegacyToken } from 'helpers/api'
import prepAndAssignUserData from './prepAndAssignUserData'

// takes Legacy token that's in the URL and fetches a new JTW
// NOTE - authorizeNewSession will call this only if the query key is 'token'
// NOTE - if this fails, the caller will catch it and send the user to /login

const createSessionWithLegacyToken = () => async dispatch => {
  const queryString = (
    window.location.hash.includes('?')
      ? window.location.hash.slice(window.location.hash.indexOf('?'))
      : window.location.search
  )

  const { entity } = await postLegacyToken(queryString)
  await dispatch(prepAndAssignUserData(entity))
}

export default createSessionWithLegacyToken
